import React from 'react';
import LogoDto from './media/logo_dto_gris.svg';
import LogoPcc from './media/logo_pcc.svg';
import LogoMarcas from './media/logos_marcas.svg';
import mexico from './media/mexico.png';
import logoSeat from './media/seat-logo-footer.svg';
import './index.css';

class Footer extends React.Component{
    render(){
        return (
            <React.Fragment>
                 <footer className={"footer__container--"+this.props.marca+" container__font--"+this.props.marca+(this.props.marca==="audi"?" pt-3 pb-3":this.props.marca==="vw"?" pt-3 pb-3":"")}>
                    <div className={"container footer__line--"+this.props.marca}>
                        <div className={"pt-0 pb-2 footer__texto--"+this.props.marca}>
                        {
                            this.props.marca==="vw"?(
                                <div className="row">
                                    <div className="col-lg-3 col-md-7 col-10 offset-lg-0 offset-1 offset-md-0">
                                        <div className="text-center marca__copyright">
                                        &#169; Volkswagen de México 2021
                                        </div>
                                    </div>
                                    <div className="col-lg-1 pt-1 col-md-2 col-3 offset-lg-3 offset-1 offset-md-0">
                                        <img src={LogoDto} alt="dto" />
                                    </div>
                                    <div className="col-lg-1 col-1 marca__border">
                                        
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-5 pt-2 pb-2">
                                        <img src={LogoPcc} alt="commercial customer" />
                                    </div>
                                    <div className="col-lg-2 col-10 offset-lg-0 offset-1 offset-md-0">
                                        <img src={LogoMarcas} className="marcas mt-2 w-75" alt="multimarca" />
                                    </div>
                                </div>
                            ):(this.props.marca==="seat"?(
                                <React.Fragment>
                                    <div className="p-3">
                                        <img src={mexico} alt="México" /> México
                                    </div>
                                    <span className="row">
                                        <div className="pt-3 pb-3 col-12 footer__logo--seat">
                                            <span className="row">
                                                <span className="col-8">
                                                    <img src={logoSeat} className="p-3" alt="SEAT" />
                                                    <p className="footer__copyrigth--seat">© 2021 Volkswagen de México, S.A. de C.V. Marca SEAT</p>
                                                </span>
                                                <span className="col-4 text-right">
                                                    <img src={LogoDto} className="p-3" alt="DTO" />
                                                </span>
                                            </span>
                                        </div>
                                    </span>
                                </React.Fragment>
                            ):(this.props.marca==="cupra"?(
                                <div className="row font-weight-light">

                                    <div className="col-6">
                                        <p className="footer__copyrigth--cupra"> 
                                            Volkswagen de México S.A. de C.V. Marca  CUPRA 2021© 
                                        </p>
                                    </div>
                                    <div className="col-6 text-right">
                                        <img src={LogoDto} alt="Logo DTO" />
                                    </div>
                                </div>
                            )
                            
                            :(
                                <div className="row">
                                    <div className="col-6">
                                        <p className="footer__copyrigth--audi"> 
                                            © 2021 AUDI AG. All rights reserved
                                        </p>
                                    </div>
                                    <div className="col-6 text-right">
                                        <img src={LogoDto} alt="Logo DTO" />
                                    </div>
                                </div>
                            )))
                        }
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        );
    }
}

export default Footer;